import React from 'react'
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { cancelItem, getMyOrder, cancelOrder, executeItem } from '../../redux/feature/orderSlice';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { b } from "../../styles/variables";
import { NavLink } from 'react-router-dom';
import Loader from '../Loader';
import { Cross as Cancel } from '@styled-icons/entypo/Cross'
import { useNavigate } from 'react-router-dom';
import { updateCartCredit } from '../../redux/feature/cartSlice';
import Modal from 'styled-react-modal';
import { toast } from 'react-hot-toast';
import { getUserInfo } from '../../redux/feature/authSlice';
import { executeItemApi } from '../../api/allAxios';
import { ROLES } from '../FoodAppConstants';

function MyOrders() {
	const myUserId = useSelector((state) => state.auth.creds.user_id)
	const navigate = useNavigate()
	const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
	const [isOrderDetailsOpen, setIsOrderDetailsOpen] = useState(false);
	const [selectedOrder, setSelectedOrder] = useState(null);
	const [opacity, setOpacity] = useState(0);
	const auth = useSelector(state=>state.auth)  
	const order = useSelector((state) => state.order)
	const cart = useSelector((state) => state.cart)
	const myOrder = order.myOrder
	const dispatch = useDispatch()

	const [orderType, SetOrderType] = useState(!localStorage.getItem("currentMyOrderPage")
		? "Breakfast" : localStorage.getItem("currentMyOrderPage")
	)
	const [B, setB] = useState(localStorage.getItem("currentMyOrderPage") ? (localStorage.getItem("currentMyOrderPage") === "Breakfast" ? 1 : 0) : 1)
	const [L, setL] = useState(localStorage.getItem("currentMyOrderPage") === "Lunch" ? 1 : 0)
	const [S, setS] = useState(localStorage.getItem("currentMyOrderPage") === "Snack" ? 1 : 0)
	const [SO, setSO] = useState(localStorage.getItem("currentMyOrderPage") === "Self-Order" ? 1 : 0)
	
	const orderData = orderType === "Breakfast" ? myOrder.BREAKFAST :
		orderType === "Lunch" ? myOrder.LUNCH :
			orderType === "Snack" ? myOrder.SNACK :
				myOrder.SELF_ORDER

	useEffect(() => {
		dispatch(getMyOrder(myUserId))
	}, []);

	useEffect(() => {
		if (isOrderDetailsOpen && selectedOrder) {
			const checkExpiration = () => {
				const order = orderData?.orderlists?.find(item => item.id === selectedOrder);
				if (order?.executedAt) {
					const currentTime = Date.now();
					const executedTime = new Date(order.executedAt).getTime();
					if ((currentTime - executedTime) / 1000 / 60 >= 3) {
						toast.error("Order view time has expired");
						toggleOrderDetailsModal();
					}
				}
			};
			checkExpiration();
			const intervalId = setInterval(checkExpiration, 10000);
			return () => clearInterval(intervalId);
		}
	}, [isOrderDetailsOpen, selectedOrder, orderData]);

	const handleClickB = (type) => {
		setB(1); setL(0); setS(0); setSO(0);
		localStorage.setItem("currentMyOrderPage", type)
		SetOrderType(type)
	}
	const handleClickL = (type) => {
		setB(0); setS(0); setL(1); setSO(0);
		localStorage.setItem("currentMyOrderPage", type)
		SetOrderType(type)
	}
	const handleClickS = (type) => {
		setB(0); setS(1); setL(0); setSO(0);
		localStorage.setItem("currentMyOrderPage", type)
		SetOrderType(type)
	}
	const handleClickSO = (type) => {
		setB(0); setS(0); setL(0); setSO(1);
		localStorage.setItem("currentMyOrderPage", type)
		SetOrderType(type)
	}

	const handleCancelOrder = (orderId) => {
		dispatch(cancelOrder(orderId))
	}
	const handleCancelItem = (item_id, food_name) => {
		dispatch(cancelItem([item_id]))
	}
	const handleExecuteItem = (item_id) => {
		dispatch(executeItem([item_id]))
	}

	function toggleConfirmationModal() {
		setOpacity(0);
		setIsConfirmationOpen(!isConfirmationOpen);
	}

	function toggleOrderDetailsModal() {
		setOpacity(0);
		setIsOrderDetailsOpen(!isOrderDetailsOpen);
	}

	function afterOpen() {
		setTimeout(() => { setOpacity(1); }, 100);
	}

	function beforeClose() {
		return new Promise((resolve) => {
			setOpacity(0);
			setTimeout(resolve, 300);
		});
	}

	const handleOrderDetail = (orderId) => {
		const currentTime = Date.now();
		const order = orderData?.orderlists?.find(item => item.id === orderId);
		
		if (order?.executedAt) {
			const executedTime = new Date(order.executedAt).getTime();
			if ((currentTime - executedTime) / 1000 / 60 >= 3) {
				toast.error("Order view time has expired");
				return;
			}
		}

		setSelectedOrder(orderId);
		if (!order?.executedAt) {
			toggleConfirmationModal();
		} else {
			toggleOrderDetailsModal();
		}
	};

	const handleConfirmView = async () => {
		toggleConfirmationModal();
		try {
			const response = await executeItemApi(selectedOrder);
			if(response.data.length > 0){
				const updatedOrder = response.data[0];
				const newOrderData = {
					...orderData,
					orderlists: orderData.orderlists.map(item => {
					if(item.id === updatedOrder.id){
						return updatedOrder;
					}
					return item;
				})}
				dispatch({
					type: 'order/setMyOrder',
					payload: [{
						...newOrderData,
						order_type: orderType.toLocaleUpperCase()
					}]
				});
				dispatch(getMyOrder(myUserId));
				toast.success("Order Executed!!");
				console.log("time_data",updatedOrder.executedAt, new Date(updatedOrder.executedAt).getTime());
				toggleOrderDetailsModal();
			}
		} catch (error) {
			if (error.response?.status === 406) {
				toast.error("Couldn't execute order after order is locked by Admin");
			} else if (error.response?.status === 401) {
				toast.error("Your Session has expired, Please login again.");
			}
		}
	};

	const handleCloseOrderDetails = () => {
		toggleOrderDetailsModal();
	};

	return (
		<>
			<MainContainer>
				<TabsWrapper>
					<TabsRow>
						<Tab active={B === 1} onClick={() => handleClickB("Breakfast")}>Breakfast</Tab>
						<Tab active={L === 1} onClick={() => handleClickL("Lunch")}>Lunch</Tab>
						<Tab active={S === 1} onClick={() => handleClickS("Snack")}>Snacks</Tab>
						<Tab active={SO === 1} onClick={() => handleClickSO("Self-Order")}>Self-Order</Tab>
					</TabsRow>
				</TabsWrapper>
				<ContentArea>
					{order.isLoading ? <Loader /> :
						<OrderPanel>{Object.keys(orderData)?.length === 0 ? 
							<EmptyOrderState>
								<EmptyEmoji>&#128203;</EmptyEmoji>
								<p>You have not placed any order for {orderType}</p>
							</EmptyOrderState> :
							(<>
								<OrderHeader>
									<OrderTitle>My Orders</OrderTitle>
									<TokenBadge>Token: <strong>{orderData?.order_id}</strong></TokenBadge>
								</OrderHeader>

								{orderType === "Self-Order" ? 
									<SelfOrderGrid>{orderData?.orderlists?.map((item, index) => {
										const isExecuted = item?.executedAt ? true : false;
										const currentTime = Date.now();
										const executedTime = item?.executedAt ? new Date(item.executedAt).getTime() : null;
										const isExpired = executedTime && (currentTime - executedTime) / 1000 / 60 >= 3;
										
										return (
											<SelfOrderCard 
												key={index} 
												onClick={() => !isExpired && handleOrderDetail(item.id)}
												isExpired={isExpired}
											>
												<SelfOrderContent>
													<h4>{item?.food?.food_name}</h4>
													{(isExecuted || isExpired) && <StatusBadge type={isExpired ? "expired" : "executed"}>
														{isExpired ? "Expired" : "Executed"}
													</StatusBadge>}
												</SelfOrderContent>
												{!isExecuted && <CancelIconBtn 
													onClick={(e) => {
														e.stopPropagation();
														!isExpired && handleCancelItem(item.id, item?.food?.food_name, myUserId);
													}} 
												><Cancel size={20} /></CancelIconBtn>}
											</SelfOrderCard>
										);
									})}</SelfOrderGrid> :
									<TableScrollWrapper>
										<TableHeader>
											<TableCol flex={1}>Name</TableCol>
											<TableCol flex={1}>Vendor</TableCol>
											<TableCol flex={0.5} center>Qty</TableCol>
											<TableCol flex={0.5} center>Amount</TableCol>
											<TableCol flex={0.3} center></TableCol>
										</TableHeader>
										<TableBody>{orderData?.orderlists?.map((item, index) => {
											const isExecuted = item?.executedAt ? true : false;
											const currentTime = Date.now();
											const executedTime = item?.executedAt ? new Date(item.executedAt).getTime() : null;
											const isExpired = executedTime && (currentTime - executedTime) / 1000 / 60 >= 3;
											
											return (
												<TableRow 
													key={index} 
													onClick={() => !isExpired && handleOrderDetail(item.id)}
													isExpired={isExpired}
												>
													<TableCol flex={1}>
														<NameCell>
															{item?.food?.food_name}
															{isExecuted && !isExpired && <StatusBadge type="executed">Executed</StatusBadge>}
															{isExpired && <StatusBadge type="expired">Expired</StatusBadge>}
														</NameCell>
													</TableCol>
													<TableCol flex={1}>{item?.food?.vendor?.vendor_name}</TableCol>
													<TableCol flex={0.5} center>{item?.quantity}</TableCol>
													<TableCol flex={0.5} center>{item?.food_prices}</TableCol>
													<TableCol flex={0.3} center>
														<CancelIconBtn 
															onClick={(e) => {
																e.stopPropagation();
																!isExpired && handleCancelItem(item.id, item?.food?.food_name, myUserId);
															}} 
														><Cancel size={20} /></CancelIconBtn>
													</TableCol>
												</TableRow>
											);
										})}</TableBody>
									</TableScrollWrapper>
								}
								<OrderFooter>
									<CancelOrderBtn onClick={() => handleCancelOrder(orderData.order_id)}>Cancel Order</CancelOrderBtn>
								</OrderFooter>
							</>)}
						</OrderPanel>
					}
				</ContentArea>
			</MainContainer>

			<StyledModal
				isOpen={isConfirmationOpen}
				afterOpen={afterOpen}
				beforeClose={beforeClose}
				opacity={opacity}
				backgroundProps={{ opacity }}
			>
				<ModalCard>
					<ModalHeader>
						<h2>Confirm Order View</h2>
						<ModalCloseBtn onClick={toggleConfirmationModal}><Cancel size={20} /></ModalCloseBtn>
					</ModalHeader>
					<ModalBody>
						<p>Once you open the order, it will be available for only 3 min. Please open it if only showing to vendor. Are you sure you want to see the order?</p>
						<ModalActions>
							<ModalPrimaryBtn onClick={handleConfirmView}>Yes</ModalPrimaryBtn>
							<ModalSecondaryBtn onClick={toggleConfirmationModal}>No</ModalSecondaryBtn>
						</ModalActions>
					</ModalBody>
				</ModalCard>
			</StyledModal>

			<StyledModal
				isOpen={isOrderDetailsOpen}
				afterOpen={afterOpen}
				beforeClose={beforeClose}
				opacity={opacity}
				backgroundProps={{ opacity }}
			>
				<ModalCard>
					<ModalHeader>
						<h2>Order Details</h2>
						<ModalCloseBtn onClick={handleCloseOrderDetails}><Cancel size={20} /></ModalCloseBtn>
					</ModalHeader>
					<ModalBody>
						{(() => {
							const order = orderData?.orderlists?.find(item => item.id === selectedOrder);
							return order ? (
								<>
									<DetailVendorName>{order?.food?.vendor?.vendor_name}</DetailVendorName>
									<DetailTableHeader>
										<DetailCol>Name</DetailCol>
										<DetailCol>Quantity</DetailCol>
										<DetailCol>Amount</DetailCol>
									</DetailTableHeader>
									<DetailDivider />
									<DetailTableRow>
										<DetailCol>{order?.food?.food_name}</DetailCol>
										<DetailCol>{order?.quantity}</DetailCol>
										<DetailCol>{order?.food_prices}</DetailCol>
									</DetailTableRow>
								</>
							) : (
								<p>Order details not found</p>
							);
						})()}
					</ModalBody>
				</ModalCard>
			</StyledModal>
		</>
	)
}

export default MyOrders;

const MainContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	font-family: 'Nunito Sans', sans-serif;
`

const TabsWrapper = styled.div`
	background: #ffffff;
	padding: 0 2.4rem;
	border-bottom: 1px solid #f4f4f5;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;

	&::-webkit-scrollbar {
		display: none;
	}

	@media ${b.mobile}{ 
		padding: 0 1.2rem;
	}
`;

const TabsRow = styled.div`
	display: flex;
	gap: 0.4rem;
	white-space: nowrap;
`;

const Tab = styled.button`
	padding: 1.4rem 2rem;
	font-size: 1.4rem;
	font-weight: ${({active}) => active ? 700 : 500};
	color: ${({active}) => active ? '#F7707D' : '#71717a'};
	background: none;
	border: none;
	border-bottom: 3px solid ${({active}) => active ? '#F7707D' : 'transparent'};
	cursor: pointer;
	font-family: 'Nunito Sans', sans-serif;
	transition: all 0.2s ease;
	min-height: 44px;
	-webkit-tap-highlight-color: transparent;

	&:hover, &:active {
		color: ${({active}) => active ? '#F7707D' : '#1e1e2d'};
	}

	@media ${b.mobile}{
		padding: 1rem 1.2rem;
		font-size: 1.25rem;
	}
`;

const ContentArea = styled.div`
	display: flex;
	justify-content: center;
	flex: 1;
	padding: 2rem;
	overflow-y: auto;

	@media ${b.mobile}{
		padding: 1rem;
	}
`;

const OrderPanel = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	border: 1px solid #f4f4f5;
	border-radius: 16px;
	width: 100%;
	max-width: 700px;
	padding: 2rem;

	@media ${b.mobile}{
		padding: 1.2rem;
	}
`;

const EmptyOrderState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 4rem 2rem;
	color: #71717a;
	font-size: 1.4rem;
`;

const EmptyEmoji = styled.span`
	font-size: 4rem;
	margin-bottom: 1rem;
`;

const OrderHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.5rem;

	@media ${b.mobile}{
		flex-direction: column;
		align-items: flex-start;
		gap: 0.5rem;
	}
`;

const OrderTitle = styled.h3`
	font-size: 1.8rem;
	font-weight: 700;
	color: #1e1e2d;
`;

const TokenBadge = styled.span`
	font-size: 1.2rem;
	background: #f4f4f5;
	padding: 4px 12px;
	border-radius: 8px;
	color: #52525b;

	strong {
		color: #1e1e2d;
	}
`;

const TableScrollWrapper = styled.div`
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	width: 100%;
`;

const TableHeader = styled.div`
	display: flex;
	padding: 1rem 0;
	border-bottom: 2px solid #f4f4f5;
	font-weight: 700;
	font-size: 1.25rem;
	color: #71717a;
	min-width: 420px;
`;

const TableBody = styled.div`
	max-height: 50vh;
	max-height: 50dvh;
	overflow-y: auto;
`;

const TableRow = styled.div`
	display: flex;
	padding: 1.2rem 0;
	border-bottom: 1px solid #fafafa;
	font-size: 1.3rem;
	color: ${props => props.isExpired ? '#a1a1aa' : '#1e1e2d'};
	opacity: ${props => props.isExpired ? 0.6 : 1};
	cursor: ${props => props.isExpired ? 'not-allowed' : 'pointer'};
	pointer-events: ${props => props.isExpired ? 'none' : 'auto'};
	transition: background 0.15s;
	min-width: 420px;

	&:hover, &:active {
		background: #fafafa;
	}
`;

const TableCol = styled.div`
	flex: ${props => props.flex || 1};
	display: flex;
	align-items: center;
	justify-content: ${props => props.center ? 'center' : 'flex-start'};
	font-weight: 500;
`;

const NameCell = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
`;

const SelfOrderGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
	padding: 1rem 0;
	max-height: 50vh;
	max-height: 50dvh;
	overflow-y: auto;

	@media ${b.mobile}{
		grid-template-columns: 1fr;
	}
`;

const SelfOrderCard = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.2rem 1.4rem;
	border: 1px solid #f4f4f5;
	border-radius: 12px;
	cursor: ${props => props.isExpired ? 'not-allowed' : 'pointer'};
	pointer-events: ${props => props.isExpired ? 'none' : 'auto'};
	opacity: ${props => props.isExpired ? 0.5 : 1};
	transition: all 0.2s ease;

	&:hover {
		border-color: ${props => props.isExpired ? '#f4f4f5' : '#F7707D'};
		box-shadow: ${props => props.isExpired ? 'none' : '0 2px 8px rgba(0,0,0,0.06)'};
	}

	h4 {
		font-size: 1.35rem;
		font-weight: 600;
		color: #1e1e2d;
	}
`;

const SelfOrderContent = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
`;

const StatusBadge = styled.span`
	font-size: 1rem;
	font-weight: 600;
	padding: 2px 8px;
	border-radius: 6px;
	background: ${props => props.type === 'expired' ? '#fef2f2' : '#f0fdf4'};
	color: ${props => props.type === 'expired' ? '#ef4444' : '#22c55e'};
`;

const CancelIconBtn = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background: none;
	border: none;
	color: #d4d4d8;
	cursor: pointer;
	padding: 10px;
	border-radius: 8px;
	transition: all 0.15s;
	min-width: 40px;
	min-height: 40px;
	-webkit-tap-highlight-color: transparent;

	&:hover, &:active {
		color: #ef4444;
		background: #fef2f2;
	}
`;

const OrderFooter = styled.div`
	display: flex;
	justify-content: center;
	padding: 2rem 0 0;
	margin-top: 1rem;
	border-top: 1px solid #f4f4f5;
`;

const CancelOrderBtn = styled.button`
	padding: 1rem 2.4rem;
	min-height: 44px;
	border-radius: 10px;
	border: 1.5px solid #ef4444;
	background: #fff;
	color: #ef4444;
	font-size: 1.35rem;
	font-weight: 600;
	cursor: pointer;
	font-family: 'Nunito Sans', sans-serif;
	transition: all 0.2s ease;
	-webkit-tap-highlight-color: transparent;

	&:hover, &:active {
		background: #ef4444;
		color: white;
	}
`;

const StyledModal = Modal.styled`
	width: 32rem;
	max-width: calc(100vw - 2rem);
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: white;
	opacity: ${(props) => props.opacity};
	transition: all 0.3s ease-in-out;
	border-radius: 16px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
`;

const ModalCard = styled.div`
	width: 100%;
	padding: 2rem;
`;

const ModalHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.5rem;
	h2 {
		margin: 0;
		font-size: 1.7rem;
		font-weight: 700;
		color: #1e1e2d;
	}
`;

const ModalCloseBtn = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 10px;
	border-radius: 8px;
	color: #71717a;
	transition: all 0.15s;
	min-width: 40px;
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	-webkit-tap-highlight-color: transparent;

	&:hover, &:active {
		background: #f4f4f5;
		color: #1e1e2d;
	}
`;

const ModalBody = styled.div`
	p {
		margin-bottom: 1.5rem;
		font-size: 1.35rem;
		line-height: 1.5;
		color: #52525b;
	}
`;

const ModalActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 0.8rem;
`;

const ModalPrimaryBtn = styled.button`
	padding: 0.8rem 2rem;
	min-height: 44px;
	border-radius: 10px;
	background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
	color: white;
	border: none;
	cursor: pointer;
	font-size: 1.3rem;
	font-weight: 600;
	font-family: 'Nunito Sans', sans-serif;
	transition: all 0.2s;
	-webkit-tap-highlight-color: transparent;
	&:hover, &:active { opacity: 0.9; }
`;

const ModalSecondaryBtn = styled.button`
	padding: 0.8rem 2rem;
	min-height: 44px;
	border-radius: 10px;
	border: 1.5px solid #e4e4e7;
	background: white;
	color: #52525b;
	cursor: pointer;
	font-size: 1.3rem;
	font-weight: 600;
	font-family: 'Nunito Sans', sans-serif;
	transition: all 0.2s;
	-webkit-tap-highlight-color: transparent;
	&:hover, &:active { background: #f8f8f8; }
`;

const DetailVendorName = styled.h3`
	text-align: center;
	font-weight: 700;
	font-size: 1.7rem;
	color: #1e1e2d;
	margin-bottom: 1.5rem;
`;

const DetailTableHeader = styled.div`
	display: flex;
	justify-content: space-between;
	font-weight: 700;
	font-size: 1.3rem;
	color: #71717a;
`;

const DetailDivider = styled.hr`
	width: 100%;
	margin: 0.8rem 0 1rem;
	border: none;
	border-top: 1px solid #f4f4f5;
`;

const DetailTableRow = styled.div`
	display: flex;
	justify-content: space-between;
	font-size: 1.4rem;
	font-weight: 600;
	color: #1e1e2d;
`;

const DetailCol = styled.div`
	flex: 1;
	text-align: center;
`;
